/** Base path for deal crawler page creation flow. */
export const DEAL_CRAWLER_PAGE_CREATION_BASE = '/cruises/deal-crawler/page-creation';

/** Selection step: choose which crawlers to include. */
export const DEAL_CRAWLER_PAGE_CREATION_SELECTION_PATH = DEAL_CRAWLER_PAGE_CREATION_BASE;

/** Confirm step: review and create the deal page. */
export const DEAL_CRAWLER_PAGE_CREATION_CONFIRM_PATH = `${DEAL_CRAWLER_PAGE_CREATION_BASE}/confirm`;

const CRAWLER_IDS_PARAM = 'crawlerIds';
const MAIN_CRAWLER_ID_PARAM = 'mainCrawlerId';

/** Build query string for deal crawler flow. mainCrawlerId is optional; if omitted, first crawler is treated as main. */
export function buildDealCrawlerPageCreationSearch(params: {
  crawlerIds: Array<string>;
  mainCrawlerId?: string;
}): string {
  const { crawlerIds, mainCrawlerId } = params;
  const search = new URLSearchParams();
  if (crawlerIds.length) {
    search.set(CRAWLER_IDS_PARAM, crawlerIds.join(','));
  }
  if (mainCrawlerId) {
    search.set(MAIN_CRAWLER_ID_PARAM, mainCrawlerId);
  }
  return search.toString();
}

export function getMainCrawlerIdFromSearch(search: string, crawlerIds: Array<string>): string | undefined {
  const main = new URLSearchParams(search).get(MAIN_CRAWLER_ID_PARAM) ?? undefined;
  if (main && crawlerIds.includes(main)) {
    return main;
  }
  return crawlerIds[0];
}
